/* VialArt / VialCase — remember the customer's uploaded logo.
   Real failure this prevents: a customer building several branded labels in
   one sitting re-uploads the logo per label and eventually forgets one
   (order #1053: 3 of 4 labels had the logo).
   - On upload: save the (already auto-cleaned) logo as a data-URL in
     localStorage (30-day TTL).
   - Same sitting (< 6h old): auto-reapply it when the builder loads with an
     empty logo slot, with a toast so it's never a surprise (+15% branded
     pricing recalcs visibly, and it can be removed in one tap).
   - Later visits (< 30d): show a one-click "Use saved logo" chip instead —
     no surprise pricing on a fresh plain-label order.
   - Removing the logo stops auto-reapply for the rest of the session.
   Fail-open everywhere. Identical file ships to BOTH themes. */
(function () {
  var KEY = 'va_logo_saved';
  var STOP = 'va_logo_stop';
  var AUTO_MS = 6 * 3600 * 1000;
  var TTL_MS = 30 * 24 * 3600 * 1000;

  function toast(m) {
    try { if (typeof window.toast === 'function') { window.toast(m); return; } } catch (e) {}
  }
  function input() { return document.getElementById('va-logo-file'); }
  function load() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || !o.d || o.d.slice(0, 11) !== 'data:image/' ) return null;
      if (Date.now() - (o.t || 0) > TTL_MS) { localStorage.removeItem(KEY); return null; }
      return o;
    } catch (e) { return null; }
  }
  function save(dataUrl) {
    try { localStorage.setItem(KEY, JSON.stringify({ d: dataUrl, t: Date.now() })); } catch (e) {}
  }
  function hasLogoNow() {
    try { if (window.customLogo) return true; } catch (e) {}
    var t = input();
    return !!(t && t.files && t.files.length);
  }
  function dataUrlToFile(d) {
    var m = /^data:(image\/[a-z0-9.+-]+);base64,(.+)$/i.exec(d);
    if (!m) return null;
    var bin = atob(m[2]), arr = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
    return new File([arr], 'saved-logo.png', { type: m[1] });
  }
  function apply(d, note) {
    var t = input();
    if (!t || typeof DataTransfer === 'undefined') return false;
    var f = dataUrlToFile(d);
    if (!f) return false;
    try {
      var dt = new DataTransfer();
      dt.items.add(f);
      t.files = dt.files;
      t.dispatchEvent(new Event('change', { bubbles: true }));
      if (note) toast(note);
      return true;
    } catch (e) { return false; }
  }

  // 1. capture uploads (bubble phase = AFTER the auto-clean interceptor swapped
  //    in the cleaned file), store for next time
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.id !== 'va-logo-file') return;
    var f = t.files && t.files[0];
    if (!f || !/^image\//.test(f.type || '')) return;
    try {
      var fr = new FileReader();
      fr.onload = function () { if (typeof fr.result === 'string') save(fr.result); };
      fr.readAsDataURL(f);
    } catch (err) {}
  }, false);

  // 2. removing the logo pauses auto-reapply for this session
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('#va-logo-rm');
    if (!b) return;
    try { sessionStorage.setItem(STOP, '1'); } catch (err) {}
    toast('Logo removed from this label — still saved for next time.');
  }, true);

  // 3. restore: auto within the same sitting, chip otherwise
  function chip(saved) {
    var t = input();
    if (!t || document.getElementById('va-logo-reuse')) return;
    var host = t.closest('.va-field') || t.parentElement;
    if (!host) return;
    var b = document.createElement('button');
    b.type = 'button'; b.id = 'va-logo-reuse';
    b.textContent = '↺ Use my saved logo';
    b.style.cssText = 'margin-top:8px;padding:8px 14px;border-radius:9px;border:1px dashed rgba(124,77,255,.65);'
      + 'background:rgba(124,77,255,.10);color:#c9b3ff;font-weight:700;font-size:12.5px;cursor:pointer;';
    b.addEventListener('click', function () {
      if (apply(saved.d, 'Your saved logo was added.')) { try { b.remove(); } catch (e) {} }
    });
    host.appendChild(b);
  }
  function boot() {
    var saved = load();
    if (!saved) return;
    var stopped = false;
    try { stopped = sessionStorage.getItem(STOP) === '1'; } catch (e) {}
    if (hasLogoNow()) return;
    if (!stopped && Date.now() - saved.t < AUTO_MS) {
      // same sitting: put the logo back on automatically
      if (!apply(saved.d, 'We added your logo again — remove it in the Logo section if you don’t want it on this label.')) chip(saved);
    } else {
      chip(saved);
    }
  }
  function wait(n) {
    if (input()) { setTimeout(boot, 600); return; }
    if (n < 40) setTimeout(function () { wait(n + 1); }, 300);
  }
  if (document.readyState !== 'loading') wait(0);
  else document.addEventListener('DOMContentLoaded', function () { wait(0); });
})();
